import { observable, decorate, action, computed } from 'mobx'
import axios from 'axios'
import ls from 'local-storage'
import _ from 'lodash'
import { message } from 'antd'
import gql from 'graphql-tag'
import client from '../../ApolloClient'

class AuthStore {

	isAuthenticated = ls.get('isAuthenticated') || false
	isPasswordChanged = ls.get('isPasswordChanged') || false
	authenticating = false
	fetchingUserDetails = false
	fetchingProfileDetails = false
	isProfileModalShown = false
	profileDetails = null
	error = null
	user_uid = ls.get('user_uid') || null
	user_type = ls.get('user_type') || null
	userDetails = null
	token = ls.get('token') || null
	barangay_uid = ls.get('barangay_uid') || null
	barangay_term_uid = ls.get('barangay_term_uid') || null
	or_required = ls.get('or_required') || false

	constructor() {
		const token = ls.get('token') || null
		if (token && this.isAuthenticated) {
			this.getUserDetails()
		}
	}

	setError(error) {
		this.error = error
	}

	authenticate = (username, password) => {
		const loginUrl = `${process.env.REACT_APP_BACKEND_API}/auth/login`
		this.authenticating = true
		return axios.post(loginUrl, { username, password })
			.then(res => {
				// console.log('login response', res)
				const { data: { success, token, data, message } } = res
				if (success) {
					const isPassChanged = _.isEqual(parseInt(data.is_password_changed), 1)
					this.setIsPasswordChanged(isPassChanged)

					ls.set('isAuthenticated', true)
					ls.set('token', token)
					// ls.set('user_uid', data.uid)
					// ls.set('user_type', data.user_type)

					// this.userDetails = data
					this.isAuthenticated = true
					// this.user_uid = data.uid
					// this.user_type = data.user_type

					this.setError(null)

					// redirect to homepage
					this.getUserDetails().then(() => {
						window.location.href = '/'
					})
				} else {
					// this.setError(new Error('Invalid Username/Password'))
					this.setError(new Error(message))
				}
				this.authenticating = false
			}).catch(err => {
				console.log('error loggin in', err)
				this.setError(err)
				this.authenticating = false
			})
	}

	getUserDetails = () => {
		const token = ls.get('token') || null

		this.fetchingUserDetails = true
		const userDetailsUrl = `${process.env.REACT_APP_BACKEND_API}/api/user/details`
		return axios({
			method: 'get',
			url: userDetailsUrl,
			headers: {
				Authorization: `bearer ${token}`,
				ServerSerialNumber: process.env.REACT_APP_SERVER_SERIAL_NUMBER
			},
			type: 'json'
		}).then((response) => {
			// console.log('user details response', response)
			const { data } = response.data
			if (_.isEqual(data.is_activated, 0) && _.isEqual(data.is_password_changed, 1)) {
				throw new Error('Your account is deactivated, please contact system administrator.')
			}

			ls.set('isAuthenticated', true)
			ls.set('user_uid', data.uid)
			ls.set('user_type', data.user_type)
			ls.set('barangay_uid', data.barangay_uid)
			ls.set('barangay_term_uid', data.barangay_term_uid)
			ls.set('or_required', data.or_required)

			this.userDetails = data
			this.isAuthenticated = true
			this.user_uid = data.uid
			this.user_type = data.user_type
			this.barangay_uid = data.barangay_uid
			this.barangay_term_uid = data.barangay_term_uid
			this.or_required = data.or_required

			this.fetchingUserDetails = false
		}).catch(err => {
			console.log('error getting user details', err.message)
			let messageResponse = err.message
			if (_.isEqual(err.message, 'Request failed with status code 505')) {
				messageResponse = 'School Account deactivated'
			} else if (_.isEqual(err.message, 'Request failed with status code 506')) {
				messageResponse = 'Invalid License Key'
			}
			message.error(messageResponse, 3, () => {
				this.isAuthenticated = false
				this.fetchingUserDetails = false
				this.logout()
			})
		})
	}

	showUserProfile = (empid) => {
		this.isProfileModalShown = true
		this.fetchingProfileDetails = true

		const profileDetailsUrl = `${process.env.REACT_APP_BACKEND_API}/api/user/smarthr-details/${empid}`
		return axios({
			method: 'get',
			url: profileDetailsUrl,
			// headers: {
			// 	Authorization: `bearer ${token}`
			// },
			type: 'json'
		}).then((response) => {
			this.profileDetails = response.data.data
			this.fetchingProfileDetails = false
		}).catch(err => {
			console.log('error getting profile details', err.message)
			this.profileDetails = null
			// this.isProfileModalShown = false
			this.fetchingProfileDetails = false
		})
	}

	closeProfileModal = () => {
		this.isProfileModalShown = false
	}

	setIsPasswordChanged = (value) => {
		ls.set('isPasswordChanged', value)
		this.isPasswordChanged = value
	}

	logout = (redirectUrl = '/') => {
		// clear localstorage
		ls.clear()

		// clear store details
		this.error = null
		this.userDetails = null
		this.profileDetails = null
		this.user_uid = null
		this.barangay_uid = null
		this.barangay_term_uid = null
		this.or_required = false
		this.user_type = null
		this.token = null
		this.isAuthenticated = false
		// this.isPasswordChanged = false
		this.fetchingUserDetails = false
		this.fetchingProfileDetails = false
		this.isProfileModalShown = false

		// redirect to homepage
		window.location.href = redirectUrl
	}

	saveAuditTrail = (params) => {
		client.mutate({
			mutation: AUDIT_TRAIL,
			variables: { input: params }
		})
	}

	toArray(_observable) {
		return JSON.parse(JSON.stringify(_observable))
	}
}

const AUDIT_TRAIL = gql`
    mutation setAuditTrail($input: JSON) {
		setAuditTrail(input: $input)
    }
`

// apply mobx for store variables to be use in react components
decorate(AuthStore, {
	isAuthenticated: observable,
	isAcceptedPrivacyPolicy: observable,
	isPresent: observable,
	authenticating: observable,
	isProfileModalShown: observable,
	fetchingUserDetails: observable,
	fetchingProfileDetails: observable,
	error: observable,
	user_uid: observable,
	barangay_uid: observable,
	barangay_term_uid: observable,
	or_required: observable,
	user_type: observable,
	userDetails: observable,
	profileDetails: observable,
	token: observable,

	authenticate: action,
	getUserDetails: action,
	setError: action,
	showUserProfile: action,
	closeProfileModal: action,
	setIsPasswordChanged: action,
	saveAuditTrail: action,
	toArray: action
})

// for debugging purposes
const store = window.auth_store = new AuthStore()

export default store
